<template>
  <div class="ui-pagination">
    <div class="ui-pagination__rows--per-page">
      <span>{{ $t('Rows per page:') }}</span>&nbsp;
      <span>
        <v-select
          v-model="amount"
          dense
          style="width: 60px;"
          hide-details
          :items="[5,10,15,25,50,100]"
          @change="changeAmount"
        />
      </span>
      
    </div>  
    <div class="ui-pagination__data">
      <DisplayNumber :number="pageStart" />-<DisplayNumber :number="pageStop" /> {{ $t("of") }}
        <DisplayNumber :number="pagination.total" />
    </div>
    <div class="ui-pagination__nav">
        <v-btn icon :disabled="pagination.page <= 1" @click="prev" color="#1b99a7">
        <v-icon>mdi-chevron-left</v-icon></v-btn>
        <v-btn icon :disabled="disableNext" @click="next" color="#1b99a7"><v-icon>mdi-chevron-right</v-icon></v-btn>
    </div>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash';
import DisplayNumber from '../DisplayNumber.vue';

  export default {
    name: 'UIPagination',
    components: {DisplayNumber},
    props: {
      pagination:{
        type: Object
      }
    },
    data(){
      return {
        amount: 5,
      };
    },
    computed:{
      pageStart(){
        if(this.pagination.page <= 1) return 1;
        return (this.pagination.page-1)*this.pagination.itemsPerPage+1;
      },
      pageStop(){
        return (this.pageStart-1)+this.pagination.result;
      },
      disableNext(){
        return this.pageStop >= this.pagination.total;
      }


    },
    watch: {
      pagination: {
        handler(value){
          this.amount = value.itemsPerPage;
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      changeAmount(value){
        const data = cloneDeep(this.pagination);
        data.itemsPerPage = value;
        data.page = 1;
        this.$emit('updatePagination', data);
      },
      prev(){
        const data = cloneDeep(this.pagination);
        data.page -=1;
        this.$emit('updatePagination', data);
      },
      next(){
        const data = cloneDeep(this.pagination);
        data.page +=1;
        this.$emit('updatePagination', data);
      }
    }

  }
</script>

<style lang="scss" scoped>
.ui-pagination{
  margin-top: 1em;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  &__rows{
    
    display: flex;
    align-items: center;
    &--per-page{
      color: #666666 !important;
  font-family: Arial, sans-serif!important;
  font-weight: 400!important;
  font-size: 14px!important;
  line-height: 16.1px!important;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      & > *::v-deep .v-select__selections{
        margin: auto 0;
      }
      & > *::v-deep .v-select__selection{
        text-align: right;
        padding-bottom: .4em;
        padding-left: .6em;
      }
      & > *::v-deep .theme--light.v-text-field > .v-input__control > .v-input__slot:before{
        border-color: #1b99a7;
      }
    }
  }

  &__data{
    padding-left: .5em;
    padding-right: .5em;
    color: #666666 !important;
  font-family: Arial, sans-serif!important;
  font-weight: 400!important;
  font-size: 14px!important;
  line-height: 16.1px!important;
  }

  &__nav{
    width: 60px;
    display: flex;
    & >  ::v-deep .v-btn:not(.v-btn--round).v-size--default{
      min-width: 30px;
      padding: 0 10px;
    }

  }

}
</style>
